"use client";

import styled from "styled-components";

export const Box = styled.div`
  background: var(--backgroundColor);
  border-radius: 0.5rem;
  padding: 15px;
`;

export const Title = styled.h2`
  font-family: "Inter Medium";
  font-size: 1rem;
  color: var(--titleColor);
  margin-bottom: 5px;
`;

export const BoxDescriptionSwitch = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const Description = styled.div`
  font-family: "Inter Regular";
  font-size: 13px;
  color: var(--textLight);
`;

export const Paragraph = styled.p`
  margin-bottom: 0;
`;

export const BoxOpen = styled.div`
  overflow: hidden;
  height: 0;
  transition: height 0.4s ease;
`;
